import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyInfo {
    name: string,
    numOfTeam: string,
    numOfEmployees: string,
    role: string,
    department: string
}

interface OnboardingState {
    currentStep: number,
    isComplete: boolean,
    company: CompanyInfo,
    loading: boolean,
    showjoyride: boolean,
    error: string | null,
    joyrideStep: number,
}

const initialState: OnboardingState = {
    currentStep: 1,
    isComplete: false,
    company: {
        name: "",
        numOfTeam: "",
        numOfEmployees: "",
        role: "",
        department: ""
    },
    loading: false,
    error: null,
    showjoyride:false,
    joyrideStep:0
}

export const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        setOnboardingStep: (state, action: PayloadAction<number>) => {
            state.currentStep = action.payload
        },
        setOnboardingComplete: (state, action: PayloadAction<boolean>) => {
            state.isComplete = action.payload
        },
        setOnboardingInfo: (state, action: PayloadAction<Partial<CompanyInfo>>) => {
            state.company = { ...state.company, ...action.payload }
        },
        setOnboardingLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setOnboardingError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        },
        setShowjoyride: (state, action: PayloadAction<boolean>) => {
            state.showjoyride = action.payload
        },
        setJoyrideStep: (state, action: PayloadAction<number>) => {
            state.joyrideStep = action.payload
        }
    }
});

export const {
        setOnboardingStep,
        setOnboardingComplete,
        setOnboardingInfo,
        setOnboardingLoading,
        setOnboardingError,
        setShowjoyride,
        setJoyrideStep
    } = onboardingSlice.actions;

export default onboardingSlice.reducer;
